<template>
<div class="body apply">
    <div class="wrap" style="width: inherit !important;">
        <div class="apply-menu-wrap1">
            <div class="top-menu">
                <h1>
                    <img v-if="logo" :src="logo" alt="company logo">
                    <div v-else style="height: 25px;" />
                    <!-- <span>사내어학과정</span> -->
                    <div style="height:30px;"></div>
                </h1>
                <!-- 모바일용 -->
                <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
                    <img src="../../assets/img/m_gnb_sub.png" alt="menu">
                </a>
                <ul>
                    <li class="on-blue">
                        <a>신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
            <!-- 반응형 메뉴 -->
            <div class="dp-inblock-m m-top-menu" id="header-menu">
                <a href="#" class="close" id="header-close">
                    <img src="../../assets/img/menu_close.png" alt="">
                </a>
                <ul class="clear">
                    <li><a class="pointer">신청하기</a></li>
                    <li><a class="pointer">신청내역 확인</a></li>
                    <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
                    <li><a class="pointer">Logout</a></li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>신청완료</h2>
                <p>신청이 완료되었습니다.</p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50 apply-fieldset">
                <div v-html="completeContents">

                </div>
                <div class="apply-program-wrap mt-20">
                    <div class="apply-select-number">
                        신청한 과정 <span class="txt-red">(2)</span>
                        <button class="pointer">다시 선택하기</button>
                    </div>
                    <div class="apply-program-select">
                        <ul>
                            <!-- 선택 했을 경우 -->
                            <li class="program-select blue">
                                <div class="apply-program-unit">
                                    <ul>
                                        <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                        <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                                            <h4 class="pay-title">미리보기 과목명 (1)</h4>
                                            <!-- <img src="../../assets/img/close.png" class="pointer" alt=""> -->
                                        </li>
                                        <li>
                                            <p>
                                                <span>언어 <b class="bold">미리보기 영어</b></span>
                                            </p>
                                            <p>
                                                <span>스케쥴 <b class="bold">2020-01-01 ~ 2020-12-31</b></span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>교육비 <b class="bold">50,000원</b></span>
                                            </p>
                                            <p>
                                                <span>교재비 <b class="bold">50,000원</b></span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="program-select blue">
                                    <div class="apply-program-unit">
                                        <ul>
                                            <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                            <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                                                <h4 class="pay-title">미리보기 과목명 (2)</h4>
                                                <!-- <img src="../../assets/img/close.png" class="pointer" alt=""> -->
                                            </li>
                                            <li>
                                                <p>
                                                    <span>언어 <b class="bold">미리보기 영어</b></span>
                                                </p>
                                                <p>
                                                    <span>스케쥴 <b class="bold">2020-01-01 ~ 2020-12-31</b></span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    <span>교육비 <b class="bold">50,000원</b></span>
                                                </p>
                                                <p>
                                                    <span>교재비 <b class="bold">50,000원</b></span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                        </ul>
                    </div>
                </div>
                <table class="hq-table-col mt-30">
                    <thead>
                        <tr>
                            <th class="txt-center">No</th>
                            <th class="txt-center">과정 명</th>
                            <th class="txt-center">신청일</th>
                            <th class="txt-center">결제금액</th>
                            <th class="txt-center">결제수단</th>
                            <th class="txt-center">결제여부</th>
                            <th class="txt-center">상태</th>
                            <th class="txt-center">수강취소</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>2</td>
                            <!-- <td class="pointer txt-blue break-all">{{item.subjectName}}</td> -->
                            <td class="pointer break-all">미리보기 과목명 1</td>
                            <td class="bold">2020-01-01</td>
                            <td>200,000원</td>
                            <td>카드</td>
                            <td class="pointer">결제완료</td>
                            <td>신청완료</td>
                            <td class="pointer txt-blue">-</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <!-- <td class="pointer txt-blue break-all">{{item.subjectName}}</td> -->
                            <td class="pointer break-all">미리보기 과목명 2</td>
                            <td class="bold">2020-01-01</td>
                            <td>200,000원</td>
                            <td>카드</td>
                            <td class="pointer">결제완료</td>
                            <td>신청완료</td>
                            <td class="pointer txt-blue">-</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="apply-agree-btn">
                <button type="button">신청내역 확인하기</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        completeContents: '',
        sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
        subjectLength: 0, // 과정 개수
        isDetailModalOpened: false, // 과정 상세보기 레이어팝업 on/off
        parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터

        logo: '' // 미리보기 로고 url용
    }),

    mounted() {
        var oParams = GetUrlParams()
        this.mainIdx = oParams.mainIdx

        var idx = this.mainIdx
        var params = {
            idx: idx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/complete/${idx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.logo = res.data.complete.company_logo_file_url
                this.completeContents = res.data.complete.complete_contents
            } else {
                alert(res.data.result)
            }
        })
    },

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
        '$route'() {
            if (this.$route.fullPath === '/user/reg/complete') {
                this.loadSugangData()
            }
        }
    },

    methods: {
        // 세션 스토리지 수강신청 전체 데이터 loading
        loadSugangData() {
            this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
            console.log('sessionData', this.sessionData)
            this.info = this.sessionData.info
            this.totalPayment = this.sessionData.totalPayment
            this.subjectLength = this.sessionData.classList[0].subjectList.length

            for (var item of this.info) {
                if (item.item_name === '이름') {
                    this.name = item.value
                    console.log('item.value', item.value)
                } else if (item.item_name.includes('E-mail@')) {
                    console.log('item.value', item.value)
                    this.email = item.value
                }
            }

            // 신청완료 된 후에는 과정 데이터 초기화
            sessionStorage.clear()
        },

        // 신청내역 확인하기 페이지로 이동
        goList() {
            this.$router.push('/user/applyList')
        },

        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            console.log(inputNumber, inputNumber)
            return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // 각 단계로 이동
        step(position) {
            this.$router.push(`/user/reg/${position}`)
        },

        // 과정선택 페이지로 이동
        moveSelectPage() {
            this.$router.push('/user/reg/select')
        },

        // 과정 상세보기 레이어팝업 열기
        openModal(data) {
            this.parentData = data
            this.isDetailModalOpened = true
        },

        // 모달 닫기
        closeModal() {
            this.isDetailModalOpened = false
        }
    }
}
</script>
